export default __webpack_public_path__ + "static/roadmap_bg_left-ae6c03ccf23d1e2ccf7039dc79db5e4d.png";